import {
  CompoundConditionNodeOutputData,
  DTCompoundConditionNode,
  DTNode,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {OutputType, ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {FALLBACK_OUTPUT_ID} from 'common/src/modules/campaignAnalytics/campaignAnalytics.types';

export function serializeCompoundConditionNode(node: DTNode, newNode: ServerNode) {
  const conditionNode = node as DTCompoundConditionNode;

  //check if node has fallback, if not, add a fallback output
  const hasFallback = !!conditionNode.outputs.find((output) => output.type === OutputType.Fallback);

  const outputs = (conditionNode.outputs as CompoundConditionNodeOutputData[]).map((output) => {
    return {
      nodeId: output.nodeId,
      sections: output.sections,
      name: output.name,
      id: output.id,
      type: output.type,
    };
  });

  return {
    ...newNode,
    createAllVariations: conditionNode.createAllVariations,
    randomizeOutputsEvaluationOrder: conditionNode.randomizeOutputsEvaluationOrder,
    description: trimDescription(newNode.description),
    outputs: hasFallback
      ? outputs
      : [
          ...outputs,
          {
            type: OutputType.Fallback,
            nodeId: NO_NODE_ID,
            id: FALLBACK_OUTPUT_ID,
            name: 'Fallback',
            sections: [],
          },
        ],
  };
}

